import React from "react";

export default function Indicator({ value }) {
  return <div className="indicator">{value}</div>;
}
